import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { itemsService } from "../services/items.service";
import type { ItemCreateRequest, ItemUpdateRequest, ListItemsParams } from "../types";

const QUERY_KEY = "items";

export function useItemsList(params: ListItemsParams) {
	return useQuery({
		queryKey: [QUERY_KEY, params],
		queryFn: () => itemsService.list(params),
		placeholderData: (previous) => previous,
	});
}

export function useCreateItem() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (data: ItemCreateRequest) => itemsService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Mahsulot qo'shildi");
		},
		onError: () => {
			message.error("Mahsulotni qo'shib bo'lmadi");
		},
	});
}

export function useUpdateItem() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: ItemUpdateRequest }) =>
			itemsService.update(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Mahsulot saqlandi");
		},
		onError: () => {
			message.error("Mahsulotni saqlab bo'lmadi");
		},
	});
}

export function useDeleteItem() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (id: string) => itemsService.remove(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Mahsulot o'chirildi");
		},
		onError: () => {
			message.error("Mahsulotni o'chirib bo'lmadi");
		},
	});
}
